import { render, staticRenderFns } from "./theGame.vue?vue&type=template&id=d54cc93e&scoped=true"
import script from "./theGame.vue?vue&type=script&lang=js"
export * from "./theGame.vue?vue&type=script&lang=js"
import style0 from "./theGame.vue?vue&type=style&index=0&id=d54cc93e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54cc93e",
  null
  
)

export default component.exports